import { applyTheme } from './theme'

export default applyTheme
